import React from "react";
import { FadeInAnimation } from "./style";

export const FadeIn = ({ children }) => {
  return <FadeInAnimation>{children}</FadeInAnimation>;
};
